module.exports = __webpack_public_path__ + "img/qr-not-found.c2924b4e.svg";